export default __webpack_public_path__ + "media/src/features/open-house-registration-my-activity/assets/calendarBrand-d68acb3ad090086a905b40fa9307171d.svg";